export default "/assets/images/carbon-monoxide-video-thumbnail.e430383dc1a2b117.jpg";